// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { Usuario } from '../comum/usuario.model';
import { Imovel } from './imovel.model';

export class ReavaliacaoImovel extends BaseResourceModel {
  constructor(
    public id?: number,
    public aux?: number,
    public processo?: string,
    public observacao?: string,
    public data_efetivacao?: Date,
    public encerrado?: boolean,
    public usuario?: Usuario,
    public orgao?: Orgao,
    public filtros?: {
      imovel?: Imovel;
      placaInicial?: number;
      placaFinal?: number;
    },
  ) {
    super();
  }

  static converteJson(json: any): ReavaliacaoImovel {
    return Object.assign(new ReavaliacaoImovel(), json);
  }
}
